import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import AppPage from "~/applications/immersive_3d_tour/app/AppPage";
import Immersive3dTourAppPageStore from "~/stores/Immersive3dTourAppPageStore";

@observer
class TourImmersive3dTourWidget extends Component {
  render() {
    const { immersive3dTourAppPageStore } = this.props;
    return <AppPage immersive3dTourAppPageStore={immersive3dTourAppPageStore} />;
  }
}

TourImmersive3dTourWidget.propTypes = {
  immersive3dTourAppPageStore: PropTypes.instanceOf(Immersive3dTourAppPageStore),
};

export default TourImmersive3dTourWidget;
